import { useRouter } from "next/router";
import { useEffect } from "react";
import Link from "next/link";
import Image from "next/image";
import { usePostHog } from "posthog-js/react";

export default function Home() {
  const router = useRouter();
  const posthog = usePostHog();
  // const access = router?.query?.code === "teddy";

  return (
    <section className="w-full h-full">
      <div className="max-w-xl mx-auto h-full">
        <div className="flex flex-col justify-between items-center mt-8 h-full">
          <h1 className="font-medium text-2xl text-[#141313] max-w-[220px] text-center">
            Discover your perfect dinner with{" "}
          </h1>
          <span className="text-6xl text-[#15BC6E] font-bold py-7">
            Dinnerfy
          </span>
          <div className="mb-8 w-[40vw] sm:mb- 0">
            <Image
              className=" m-auto"
              src="/womenCooking.png"
              alt="Women preparing food"
              width={300}
              height={300}
            />
          </div>
        </div>
        <div className="px-7 sm:w-3/4 mx-auto sm:pt-0">
          <Link
            className="flex my-6 bg-[#15BC6E] text-lg font-semibold rounded-xl text-white items-center gap-x-4 justify-center py-2 border border-slate-200 duration-300 ease-out active:scale-95 hover:bg-[#15BC65]"
            // href={`${
            //   access
            //     ? "/onboarding?formId=bo8WRvJV&url=onboard"
            //     : "https://dinnerfy.com/#container02"
            // }`}
            href={"/onboarding?formId=bo8WRvJV&url=onboard"}
          >
            Get Started
          </Link>
          <p className="font-normal text-base text-center text-[#141313]">
            Already have an account?{" "}
            <Link className="text-[#15BC65]" href={"/signin"}>
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
}
